import { Component, computed, inject } from '@angular/core';

import { MessageBarService, translator, UiCoreModule, Validators } from '@softline/ui-core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DeveloperService } from '../service/developer.service';

@Component({
    selector: 'soft-admin-settings',
    imports: [UiCoreModule, ReactiveFormsModule],
    templateUrl: './developer-settings.component.html',
    styleUrls: ['./developer-settings.component.css']
})
export class DeveloperSettingsComponent {

  private service = inject(DeveloperService);
  messageBarService = inject(MessageBarService)
  isDeveloper = computed(() => this.service.isDeveloper());
  t = translator();

  form = new FormGroup({
    password: new FormControl<string | null>(null, [Validators.required()]),
    remember: new FormControl<boolean>(false)
  })

  async onSubmit(): Promise<void> {
    try {
      const password = this.form.value.password;
      if(!password)
        return;
      const result = await this.service.su(password);
      if(result)
        this.messageBarService.success(this.t("#APPLICATION.DEVELOPER.SETTINGS.LOGIN_SUCCESS")());
      else
        this.messageBarService.error(this.t("#APPLICATION.DEVELOPER.SETTINGS.LOGIN_ERROR")());

      this.form.reset();
    }
    catch (e) {
      console.error(e);
    }
  }

  async onExit(): Promise<void> {
    await this.service.exit();
    this.messageBarService.success(this.t("#APPLICATION.DEVELOPER.SETTINGS.LOGOUT_SUCCESS")());
  }

}
